// Shared geography for the 3D viewer: a local flat projection in kilometres.
// x grows east, z grows south, and y is depth in kilometres (negative down)
// before vertical exaggeration is applied by the depth group's scale.
export const LAKES = Object.freeze(["superior", "michigan", "huron", "erie", "ontario"]);
export const LAKE_IDS = Object.freeze({ superior: 1, michigan: 2, huron: 3, erie: 4, ontario: 5 });
export const LAKE_NAMES = Object.freeze({
  superior: "Lake Superior", michigan: "Lake Michigan", huron: "Lake Huron", erie: "Lake Erie", ontario: "Lake Ontario"
});
// 2D map views for "Open in map" links.
export const LAKE_MAP_VIEWS = Object.freeze({
  erie: [42.2, -81.2, 8], huron: [45.0, -82.5, 7], michigan: [43.5, -86.5, 7], ontario: [43.7, -77.8, 8], superior: [47.5, -87.5, 6]
});
export const ORIGIN = Object.freeze({ latitude: 45.2, longitude: -84.1 });
export const KM_PER_DEGREE_LATITUDE = 111.32;
export const KM_PER_DEGREE_LONGITUDE = KM_PER_DEGREE_LATITUDE * Math.cos(ORIGIN.latitude * Math.PI / 180);
// While one lake is in focus, the others keep this fraction of their relief. The
// lakebed shader and the camera's floor must agree on it.
export const CONTEXT_RELIEF = 0.28;

export function toWorld(latitude, longitude) {
  return [
    (longitude - ORIGIN.longitude) * KM_PER_DEGREE_LONGITUDE,
    -(latitude - ORIGIN.latitude) * KM_PER_DEGREE_LATITUDE
  ];
}

export function fromWorld(x, z) {
  return [ORIGIN.latitude - z / KM_PER_DEGREE_LATITUDE, ORIGIN.longitude + x / KM_PER_DEGREE_LONGITUDE];
}

export function distanceKm(a, b) {
  const [ax, az] = toWorld(a[0], a[1]);
  const [bx, bz] = toWorld(b[0], b[1]);
  return Math.hypot(bx - ax, bz - az);
}
